import React, {Fragment} from 'react';
import {useTranslation} from "react-i18next";
import {isMobile} from "react-device-detect";
import {ORDER_VOD_ADD_DATE} from "constant/order";
import PlaylistVodSwiper from "components/boards/playlist/PlaylistVodSwiper";
import PlaylistHomeItem from "components/boards/playlist/PlaylistHomeItem";
import PlaylistLink from "components/boards/playlist/PlaylistLink";
import ConditionWrapper from "components/ConditionWrapper";
import {HOME_PLAYLIST} from "constant/playlist.display";
import classNames from "classnames";
import {gtag} from "helpers";



const PlayListSection2 = ({ loading, playlists }) => {

    const { t } = useTranslation();

    // 재생목록 리스트가 없을 경우
    if (!loading && playlists.length === 0) {
        return null;
    }

    // 진입 로그 경로
    const inflowPath = ["separate", "station", "home", "playlist"];


    return (
        !loading && playlists.length > 0 && (
            /*플레이 리스트 3개 */
            playlists.map((playlist, key) => {

                // playlistUcc > bbsTitle[0] = [ count, ucc, ... ], ...

                // 플레이리스트 첫번째 VOD
                const goPlayListTitle = { ...playlist, bbsTitle: playlist.playlistUcc[0].bbsTitle[0]};


                {/* 로딩 후 재생 목록이 있을 경우 */}
                return (
                    // 플레이리스트 정보
                    <Fragment key={`home_playlist_${playlist.idx? playlist.idx : key}`}>
                        <div className={isMobile ? "" : "play_list_wrap"}>

                            <ConditionWrapper condition={!isMobile} wrapper={<h3 className={classNames("ic play_list")} />} denyWrapper={<h2 className={classNames("ic-vod")} />}>
                                <PlaylistLink playlist={goPlayListTitle} inflowPaths={inflowPath}
                                              playlistPathType={HOME_PLAYLIST}>
                                    {playlist.title}
                                    <em>({playlist.count.playlist_cnt})</em>
                                </PlaylistLink>
                            </ConditionWrapper>

                            <section className="sct-playlist" onClick={gtag("home", "playlist")}>
                                {isMobile ? (
                                    /* Mobile의 경우 VOD 순서 대로 노출 */
                                        <PlaylistHomeItem
                                            playlist={playlist}
                                            inflowPath={inflowPath}
                                        />
                                ) : (
                                    /* PC 홈 재생목록 VOD 슬라이드 */
                                    <PlaylistVodSwiper
                                        key={`home_playlist_${playlist.idx? playlist.idx : key}`}
                                        playlist={playlist}
                                        inflowPath={inflowPath}
                                    />
                                )}
                            </section>

                        </div>
                    </Fragment>
                );
            })
        ) // end of playlist2.map
    );

};

export default PlayListSection2;